import { createFileRoute, Link, redirect } from "@tanstack/react-router";

import { buttonVariants } from "@/components/ui/button";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { cn } from "@/lib/utils";

export const Route = createFileRoute("/invite/$token/$")({
  beforeLoad: async ({ params }) => {
    // Redirect legacy Clerk multi-step sub-routes back to the token landing page,
    // which will then redirect to /invite/accept with the proper Clerk ticket.
    throw redirect({ to: "/invite/$token", params: { token: params.token } });
  },
  component: InviteSignUpCatchAll,
});

function InviteSignUpCatchAll() {
  return (
    <div className="flex flex-1 items-center justify-center px-4">
      <Card className="w-full max-w-md">
        <CardHeader className="text-center">
          <CardTitle>Invitation Error</CardTitle>
          <CardDescription>
            This invitation link is no longer valid. Please use the link from your invitation email.
          </CardDescription>
        </CardHeader>
        <CardContent className="text-center">
          <Link to="/sign-in" className={cn(buttonVariants({ variant: "outline" }))}>
            Sign in
          </Link>
        </CardContent>
      </Card>
    </div>
  );
}
